<!--
Context Menu mixim
Harbour the context menu specific functions
-->
<script>
export default {
    data() {
        return {};
    },
    methods: {
        showToolbox: function (id, countryId, brandId, storedData, key) {
            if(key === 'prices__price_incl_tax' && countryId === 'DE') {
                this.$root.$emit('bv::hide::popover');
                this.$root.$emit('bv::show::popover', 'col__'+key+'__'+id);
                return false;
            }

            return true;
        },

    }
}
</script>
